import React, { useRef, useState } from "react";
import { api, imgUrl } from "@/lib/api";
import { toast } from "sonner";
import { Upload, Loader2, X } from "lucide-react";

export default function ImageUpload({ value, onChange, testId = "image" }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error("Upload failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="font-admin" data-testid={testId}>
      <div className="flex items-center gap-4">
        {value ? (
          <div className="relative w-24 h-24 rounded-md overflow-hidden border border-gray-200 shrink-0">
            <img src={imgUrl(value)} alt="preview" className="w-full h-full object-cover" />
            <button type="button" onClick={() => onChange("")} className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-1" data-testid={`${testId}-remove`}><X size={12} /></button>
          </div>
        ) : (
          <div className="w-24 h-24 rounded-md border border-dashed border-gray-300 flex items-center justify-center text-gray-400 shrink-0"><Upload size={20} /></div>
        )}
        <div className="flex-1">
          <button type="button" onClick={() => ref.current.click()} disabled={busy} data-testid={`${testId}-upload-btn`}
            className="inline-flex items-center gap-2 border border-gray-300 rounded-md px-3 py-2 text-sm font-medium hover:bg-gray-50 transition-colors">
            {busy ? <Loader2 className="animate-spin" size={15} /> : <Upload size={15} />} Upload image
          </button>
          <input ref={ref} type="file" accept="image/*" className="hidden" onChange={handle} data-testid={`${testId}-input`} />
          <input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="…or paste image URL"
            className="w-full mt-2 border border-gray-200 rounded-md px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#0A0A0A]" data-testid={`${testId}-url`} />
        </div>
      </div>
    </div>
  );
}
